import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class RegionalTags extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'RegionalTags'
}
const servicePath = 'regional-tags'
const servicePlugin = makeServicePlugin({
  Model: RegionalTags,
  // IMPORTANT
  whitelist: ['$eager', '$iRegexp', '$regex', '$options', '$mergeEager', '$service', '$query', '$select', '$field'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
